module.exports = __webpack_public_path__ + "static/img/COC2021-8.59b0ea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-8.jpg
// module id = hwum
// module chunks = 0